<template>
    <div class="content">
      <ph-header>
        <van-icon name="arrow-left" size="20px" slot="left" @click="$router.back(-1)" />
      </ph-header>
      <section class="address-wrapper">
         <!-- :address-info='AddressInfo' -->
        <van-address-edit
          :area-list="areaList"
          show-delete
          :address-info="AddressInfo"
          :is-saving="isSaving"
          show-set-default
          @save="onSave"
          @change-default='onChangeDefault'
          @delete="onDelete"
        />
      </section>
    </div>
</template>

<script>
// import areaList from '@/utils/areaList.js'
import PhHeader from '@/components/common/Header'
import { AddressEdit } from 'vant'
// , getDefaultAddress
import { initAreaList, postAddressEdit } from '@/api/user'
export default {
  data () {
    return {
      isSaving: false,
      addressId: '',
      initAddressData: {},
      params: {},
      return_url: ''
    }
  },
  components: {
    PhHeader,
    [AddressEdit.name]: AddressEdit
  },
  computed: {
    AddressInfo () {
      return this.$store.getters.editAddress
    },
    token () {
      return this.$store.getters.token
    },
    IdToAreaCode () {
      let map = this.$store.getters.defaultAreaList.alignmentCorrespondingDictionary
      return map || this.getInitAreaList()
    },
    areaCodeToId () {
      let map = this.$store.getters.defaultAreaList.correspondingDictionary
      return map || this.getInitAreaList()
    },
    areaList () {
      let _areaList = this.$store.getters.defaultAreaList
      return _areaList || this.getInitAreaList()
    }
  },
  mounted () {
    this.addressId = this.$route.query.aid
    this.return_url = this.$route.query.return_url || '/'
  },
  methods: {
    // 查询地址信息
    // getAddressInfo () {
    //   getDefaultAddress({ addressId: this.addressId, userToken: this.token }).then(res => {
    //     this.initAddressData.id = res.addressId
    //     this.initAddressData.tel = res.tel
    //     this.initAddressData.name = res.receiver
    //     this.initAddressData.areaCode = this.IdToAreaCode[res.areaId]
    //     this.initAddressData.addressDetail = res.detailedAddress
    //     this.initAddressData.isDefault = res.defaultAddress !== 2
    //   }).catch(err => {
    //     this.$toast(err)
    //   })
    // },
    getInitAreaList () {
      initAreaList().then(res => {
        this.$store.commit('SET_DEFAULT_AREA_LIST', res)
      }).catch(err => {
        this.$toast(err)
      })
    },
    onSave (content) {
      console.log(content)

      this.params.addressId = content.id
      this.params.userToken = this.token

      this.params.areaCode = content.areaCode
      this.params.detailedAddress = content.addressDetail

      this.params.provinceId = this.areaCodeToId[content.areaCode.slice(0, 2) + '0000']
      this.params.cityId = this.areaCodeToId[content.areaCode.slice(0, 4) + '00']
      this.params.areaId = this.areaCodeToId[content.areaCode]
      this.params.connection = `${content.province}${content.city}${content.county}`

      this.params.tel = content.tel
      this.params.receiver = content.name

      this.params.defaultAddress = content.isDefault ? '1' : '2'
      this.params.editType = 2

      this.isSaving = true
      postAddressEdit(this.params).then(res => {
        
        this.$toast('修改成功')
        this.$router.replace({ name: 'address' })
      })
    },
    onDelete () {
      postAddressEdit({ addressId: this.addressId, userToken: this.token, editType: 3 }).then(res => {
        this.$router.replace({ name: 'address' })
        this.$toast('删除成功')
      })
    },
    onChangeDefault () {
      // 设置默认地址
      // this.$toast('delete')
    }

  }
}
</script>

<style lang="less" scoped>

</style>
